module.exports = __webpack_public_path__ + "img/ukjent_driver_med_paavirkningsgrad.3d4f2ade.jpg";